export default __webpack_public_path__ + "static/media/strandKlein.183003bc.jpg";